/* bundle-ux.js — badge per riga con RISPARMIO in € (drawer + cart page, compatibile BSS) + ping recalc + coexist con BSS */
(function () {
  const DEBUG = true;
  const TAG = '[bundle-ux]';
  const log  = (...a)=>{ if (DEBUG) console.log(TAG, ...a); };
  const warn = (...a)=>{ if (DEBUG) console.warn(TAG, ...a); };

  const SEL = {
    line:  '.cart-line, .cart-item, .cart__item, tr.cart-item',
    title: '.cart-line__title, .cart-item__title, .cart-item__name, .cart__name, .cart__product-title',
    slot:  '.bndl-badge-slot',
    roots: [
      '.cart-drawer', '.drawer__body', '.cart__items', '[data-cart-items]',
      'form[action="/cart"]', '#cart-form', '.cart', 'body'
    ],
    totals: '.bss-b2b-cart-total-price, [data-cart-total], .totals__subtotal-value'
  };

  const $$ = (s, r=document) => Array.from(r.querySelectorAll(s));
  const debounce = (fn, w=120) => { let t; return (...a)=>{ clearTimeout(t); t=setTimeout(()=>fn(...a), w); }; };
  const vidOf = o => o?.variant_id ?? o?.variant ?? o?.variantId ?? o?.id ?? null;

const BSS_ACTIVE =
  !!document.querySelector('.bss-b2b-cart-total-price') ||
  !!window.bssb2b || !!window.BSSB2B || !!window.bssB2B;

// --- Fix compatibilità BSS ---
// Se il sistema BSS è attivo, evitiamo di forzare ricalcoli di Bundler
// (BSS gestisce già i totali scontati e il ping doppio può creare flicker visivo)
if (BSS_ACTIVE) {
  suppressRecalc = true;
  if (DEBUG) log('BSS rilevato: disattivato il ping Bundler per compatibilità');
}



  let bundlerVids = new Set();
  let suppressRecalc = false;          // quando c’è SOLO sconto Shopify (niente bundle)
  let lastBundlerDetail = null;        // per poter riscrivere i totali dopo mutazioni DOM

  function hasShopifyDiscount(detail){
    const dc  = detail?.discounted_cart_object || {};
    const has = (Array.isArray(dc.cart_level_discount_applications) && dc.cart_level_discount_applications.length > 0)
             || (Array.isArray(dc.discount_codes) && dc.discount_codes.length > 0);
    return has;
  }

  function makeMoneyFmt(detail){
    const cur = detail?.discounted_cart_object?.currency
             || (window.Shopify && Shopify.currency && Shopify.currency.active)
             || document.documentElement.getAttribute('data-shop-currency')
             || 'EUR';
    const loc = navigator.language || 'it-IT';
    const fmt = new Intl.NumberFormat(loc, { style:'currency', currency:cur });
    return cents => fmt.format((Number(cents||0))/100);
  }

  // ---- Bundler → chiedi ricalcolo (non tocchiamo noi i totali) ----
  const askRecalc = (() => {
    const RETRIES = [0, 120, 300, 700];
    let burstId = 0;
    return (why='') => {
      if (suppressRecalc) return;
      if (!window.bndlr || typeof window.bndlr.updateCartDiscounts !== 'function') return;
      const id = ++burstId;
      if (DEBUG) log('bndlr.updateCartDiscounts()', { why, retries: RETRIES, BSS_ACTIVE });
      RETRIES.forEach(d => setTimeout(()=>{ if (id===burstId) { try{ window.bndlr.updateCartDiscounts(); }catch{} }}, d));
    };
  })();
  const askRecalcDebounced = debounce(() => askRecalc('mut'), 100);

  // ---- Totali: quando ci sono bundle, scriviamo quello di Bundler (compatibile con BSS) ----
  function writeBundlerTotals(detail){
    if (!detail) return;
    const fmt = makeMoneyFmt(detail);
    const cents = Number(detail.total_amount_discounted ?? detail.discounted_cart_object?.total_price ?? 0);
    const text  = fmt(cents);
    const nodes = $$(SEL.totals);
    if (!nodes.length) return;
    // micro-retry: BSS (o tema) spesso riscrive; noi rimettiamo il valore corretto 3 volte
    [0, 80, 220].forEach(delay => {
      setTimeout(() => {
        nodes.forEach(n => { n.textContent = text; n.style.visibility = ''; });
        if (DEBUG) log('writeBundlerTotals', { delay, value: text, nodes: nodes.length });
      }, delay);
    });
  }
  const writeBundlerTotalsDebounced = debounce(() => writeBundlerTotals(lastBundlerDetail), 80);

  // ---- Totali: quando NON ci sono bundle ma c’è sconto Shopify, lasciamo a Shopify/BSS
  // (se vuoi puoi rimettere il vecchio patch /cart.js qui, ma per compatibilità lo evito)

  // ---- util varianti / badge ----
  function getVidFromLine(line){
    const attr = line.getAttribute('data-variant-id'); if (attr) return String(attr);
    const qi = line.querySelector('.quantity__input[data-quantity-variant-id]');
    if (qi && qi.dataset.quantityVariantId) return String(qi.dataset.quantityVariantId);
    const rem = line.querySelector('a[href*="/cart/change"]');
    if (rem) { const m = rem.getAttribute('href').match(/id=(\d+)/); if (m) return m[1]; }
    const a = line.querySelector('a[href*="variant="]');
    if (a) { try { const u = new URL(a.getAttribute('href'), location.origin); const v = u.searchParams.get('variant'); if (v) return v; } catch(_){} }
    return '';
  }

  function setBadge(line, on, text, tooltip){
    if (!on) {
      line.removeAttribute('data-bundle');
      line.classList.remove('is-bundle');
      const old = line.querySelector(SEL.slot);
      if (old) old.remove();
      return;
    }
    let label = (text == null ? '' : String(text)).trim();
    if (!label) label = 'Bundle';
    let slot = line.querySelector(SEL.slot);
    if (!slot) {
      const title = line.querySelector(SEL.title);
      if (!title) return;
      slot = document.createElement('span');
      slot.className = 'bndl-badge-slot';
      slot.setAttribute('aria-hidden','true');
      title.insertAdjacentElement('afterend', slot);
    }
    line.setAttribute('data-bundle','1');
    line.classList.add('is-bundle');
    slot.textContent = label;
    if (tooltip) slot.title = tooltip; else slot.removeAttribute('title');
  }

  function buildLabelMap(detail){
    const map = new Map();
    bundlerVids = new Set();
    const fmt = makeMoneyFmt(detail);

    const discItems = detail?.discounted_cart_object?.items || [];
    const saveByVid = new Map();
    discItems.forEach(it => {
      const vid  = String(vidOf(it) || '');
      const orig = Number(it.original_line_price || 0);
      const disc = Number(it.line_price || 0);
      const save = Math.max(0, orig - disc);
      if (vid) saveByVid.set(vid, save);
    });

    const combos = detail?.applicable_combos || [];
    combos.forEach(obj => {
      Object.values(obj || {}).forEach(c => {
        const vid = String(vidOf(c) || '');
        if (vid) bundlerVids.add(vid);
      });
    });

    bundlerVids.forEach(vid => {
      const saveCents = saveByVid.get(vid) || 0;
      const isVolume = combos.some(obj => Object.values(obj||{}).some(c => String(vidOf(c)||'') === vid && !!c?.volume_discount));
      const base = isVolume ? 'Bundle Volume' : 'Bundle';
      const text = saveCents > 0 ? `${base} (−${fmt(saveCents)})` : base;
      map.set(vid, { text, saveCents });
    });

    return map;
  }

  function enrichWithApi(currentMap, detail, done){
    if (!(window.bndlr && typeof window.bndlr.getCheckoutInfo === 'function')) return done(currentMap);
    const fmt = makeMoneyFmt(detail);
    const discItems = detail?.discounted_cart_object?.items || [];
    const saveByVid = new Map(discItems.map(it => [ String(vidOf(it)||''), Math.max(0,(Number(it.original_line_price||0)-Number(it.line_price||0))) ]));
    window.bndlr.getCheckoutInfo((info) => {
      try {
        const items = (info && info.items) || [];
        (function flat(arr){
          (arr || []).forEach(it => {
            if (Array.isArray(it?.items)) return flat(it.items);
            const vid = String(vidOf(it) || '');
            const ad  = it?.applied_discount;
            if (!vid || !ad) return;
            bundlerVids.add(vid);
            const prev = currentMap.get(vid) || {};
            const saveCents = prev.saveCents ?? saveByVid.get(vid) ?? 0;
            const baseTitle = ad.title || ad.description || 'Bundle';
            const text = saveCents > 0 ? `${baseTitle} (−${fmt(saveCents)})` : baseTitle;
            currentMap.set(vid, { text, saveCents, tooltip: baseTitle });
          });
        })(items);
      } catch(_) { /* noop */ }
      done(currentMap);
    });
  }

  let labelMap = new Map();

  function render(){
    $$(SEL.line).forEach(li => {
      const vid = getVidFromLine(li);
      const entry = vid && labelMap.get(String(vid));
      if (entry) setBadge(li, true, entry.text, entry.tooltip);
      else       setBadge(li, false);
    });
  }
  const reRender = debounce(render, 60);

  // ---------------- Eventi ----------------
  document.addEventListener('bundler:total_cart_values', (e) => {
    const d = e.detail || {};
    lastBundlerDetail = d;

    const shopifyDisc = hasShopifyDiscount(d);
    const base = buildLabelMap(d);
    const hasBundle = bundlerVids.size > 0;

    // se c'è SOLO sconto Shopify (e nessun bundle) → non chiediamo recalc e non scriviamo totali
    suppressRecalc = !!shopifyDisc && !hasBundle;
    if (DEBUG) log('totals event', { BSS_ACTIVE, shopifyDisc, hasBundle, suppressRecalc });

    enrichWithApi(base, d, (finalMap) => { labelMap = finalMap; reRender(); });

    // quando ci sono bundle, scrivi sempre il totale di Bundler (sovrascrive quello di BSS/tema se serve)
    if (hasBundle) writeBundlerTotals(d);
  });

  document.addEventListener('bndlr:bundle_added_to_cart', () => { askRecalc('bundle-added'); reRender(); });

  SEL.roots.forEach(sel => {
    const root = document.querySelector(sel);
    if (!root) return;
    new MutationObserver(() => {
      askRecalcDebounced();
      reRender();
      // se ci sono bundle (abbiamo lastBundlerDetail) riscrivi totali dopo le mutazioni (BSS spesso override)
      if (lastBundlerDetail && bundlerVids.size > 0) writeBundlerTotalsDebounced();
    }).observe(root, { childList:true, subtree:true, attributes:true });
  });

  document.addEventListener('click',  e => {
    if (e.target.closest('.quantity__button')) { askRecalc('qty-btn'); reRender(); if (lastBundlerDetail && bundlerVids.size>0) writeBundlerTotalsDebounced(); }
  });
  document.addEventListener('change', e => {
    if (e.target.closest('.quantity__input'))  { askRecalc('qty-input'); reRender(); if (lastBundlerDetail && bundlerVids.size>0) writeBundlerTotalsDebounced(); }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { render(); askRecalc('init'); });
  } else {
    render(); askRecalc('init');
  }

  if (DEBUG) log('BSS_ACTIVE =', BSS_ACTIVE);
})();
